
export const name = "signup-ui-lego";
export const version = "dev";
